export const USER_AUTHORIZATION_TOKEN_KEY = 'USER_AUTHORIZATION_TOKEN';
export const USER_SESSION_STATE_KEY = 'USER_SESSION_STATE';
export const USER_SESSION_CACHED = 'USER_SESSION_CACHED';
export const USER_SESSION_REFRESHED = 'USER_SESSION_REFRESHED';
export const LOGIN_VISIT_REDIRECT_PATH = 'LOGIN_VISIT_REDIRECT_PATH';
export const USER_SESSION_ID = 'USER_SESSION_ID';
export const USER_SESSION_COOKIE_EXPIRY_TIME =
  'USER_SESSION_COOKIE_EXPIRY_TIME';
/**
 * Domains for which we want to enable bulk operations via Catalyst V2 APIs
 */
export const CATALYST_V2_ALLOWED_DOMAINS = ['MC', 'INTERVENTIONS', 'WA', 'DT'];
export const BULK_EMAILS_ALLOWED_DOMAINS = ['MC'];

/**
 * Master switch for the Delete Attachments feature. While false the feature
 * is disabled for every domain regardless of the allowlist below. Flip to
 * true to enable the feature.
 */
export const IS_ATTACHMENT_DELETION_ENABLED = true;

/**
 * Domains for which the Delete Attachments page is available.
 */
export const ATTACHMENT_DELETION_ALLOWED_DOMAINS = ['MC', 'DALI', 'BALI'];

/**
 * Per-user gate layered on top of the domain allowlist: a user must be in this
 * set AND on an enabled domain to see or reach the Delete Attachments page.
 */
export const ATTACHMENT_DELETION_ALLOWED_ALIASES = new Set<string>([
  'sharekhk',
  'gourneni',
  'pratgp'
  // TODO: add more permitted aliases.
]);

export const isAttachmentDeletionAllowedForAlias = (alias?: string): boolean =>
  !!alias && ATTACHMENT_DELETION_ALLOWED_ALIASES.has(alias);

export const isAttachmentDeletionEnabledForDomain = (
  domainId: string
): boolean =>
  IS_ATTACHMENT_DELETION_ENABLED &&
  ATTACHMENT_DELETION_ALLOWED_DOMAINS.includes(domainId);

// Page available to this user: domain gate AND alias allowlist must pass.
export const isAttachmentDeletionEnabledForUser = (
  domainId: string,
  alias?: string
): boolean =>
  isAttachmentDeletionEnabledForDomain(domainId) &&
  isAttachmentDeletionAllowedForAlias(alias);
